import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"

import { cn } from "@/lib/utils"
import { useDesign } from "@/contexts/DesignContext"
import { studioMenuSide, studioAvoidCollisions } from "@/lib/studio-popper"

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

// Studio: a popover with no side of its own opens downward like a menu
// (doc 120 · D16a).  The three popovers that ask for `side="top"` by name (the
// reaction and emoji pickers, which sit at the foot of a post) keep their own
// placement and Radix's own collision handling — logged as question Q2.
const PopoverContent = React.forwardRef(({ className, align = "center", sideOffset = 4, side, avoidCollisions, ...props }, ref) => {
  const { isStudio } = useDesign();
  return (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      side={side}
      sideOffset={sideOffset}
      avoidCollisions={studioAvoidCollisions(isStudio && !side, avoidCollisions)}
      className={cn(
        "z-50 w-72 rounded-xl border bg-popover p-4 text-popover-foreground shadow-lg outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-popover-content-transform-origin] duration-200",
        className
      )}
      {...props} />
  </PopoverPrimitive.Portal>
  );
})
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
